var _sentryCollisionFreeGlobalObject = typeof window === "undefined" ? global : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"0126d7f764610e46736a9965fc34ea7ea2c8620f"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN, // Replace with your actual DSN from Sentry
  tracesSampleRate: 0.2,
  environment: process.env.NEXT_PUBLIC_ENVIRONMENT || 'development',
  beforeSend(event, hint) {
    // Capture additional context from axios errors
    if (hint?.originalException) {
      const error = hint.originalException as any;

      // If it's an axios error, capture request/response data
      if (error?.isAxiosError && error?.config) {
        event.contexts = event.contexts || {};

        // Parse request data if it's a string
        let requestData = error.config.data;
        if (typeof requestData === 'string') {
          try {
            requestData = JSON.parse(requestData);
          } catch {
            // Keep as string if not valid JSON
          }
        }

        event.contexts.httpRequest = {
          method: error.config.method?.toUpperCase(),
          url: error.config.url,
          data: requestData,
          params: error.config.params,
          headers: error.config.headers,
        };

        // Capture response if available
        if (error?.response) {
          event.contexts.httpResponse = {
            status: error.response.status,
            statusText: error.response.statusText,
            data: error.response.data,
          };
        }
      }
    }
    return event;
  },
});
